import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import User from "../../store/models/User";
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  computed: {
    users: function users() {
      var _this = this;

      return Object.values(User.logins).filter(function (user) {
        return user.user_id !== _this.me.user_id;
      });
    }
  },
  methods: {
    switchUser: function switchUser(user) {
      var _this2 = this;

      if (this.me.user_id !== user.user_id) {
        this.$q.loading.show();
        User.$switchUser(user.user_id).catch(function () {
          // If the request fails we ask the user to reinsert the password for the other user.
          if (_this2.$store.state.entities.users.switchingUser) {
            _this2.openDialog('AddUser', {
              user: user
            });
          }
        }).finally(function () {
          _this2.$q.loading.hide();
        });
      }
    },
    logoutUser: function logoutUser(user) {
      var _this3 = this;

      this.showLoading();
      User.$logout(user).finally(function () {
        _this3.$forceUpdate();

        _this3.hideLoading();
      });
    }
  }
};